import styled from 'styled-components'

export const _PanelDropdown = styled.div`
  margin-right: 12px;
  position: relative;
  min-width: 144px;
  height: 36px;
  text-align: left;
  > div {
    height: 36px;
    padding: 8px 30px 8px 8px;
  }
  svg {
    right: 10px;
    top: 50% !important;
    transform: translateY(-50%);
    position: absolute;
  }
  ${({ dropdownContentSide }) => {
    switch(dropdownContentSide) {
      case 'left':
        return 'left: 0;'
      case 'right':
        return `
          right: 0;
          left: initial;
          width: calc(100% - 24px);
        `
    }
  }}
  .dropdown {
    padding: 12px !important;
    width: calc(100% + 260px);
    left: calc(-100% - 24px);
    border: none !important;
    top: 38px;
    box-shadow: 3px 3px 5px 0 rgba(0,0,0,0.3);
  }
  .dropdownTitle {
    width: 100%;
    white-space: nowrap;
  }
  ${({ gridStyle }) => (gridStyle && `
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
    grid-gap: 5px;
  `)}
`

export const _Title = styled.div`
  max-width: 110px;
`
